import type { User } from '@iheartjane/data-access';
import Moe from '@moengage/web-sdk';
import { useEffect } from 'react';

/* eslint-disable import-x/no-named-as-default-member */
const identifyToMoengage = async (user: Partial<User>) => {
  if (Moe.isMoeLoaded()) {
    const moeUserEmail = Moe.getUserIdentities()?.['u_em'];
    try {
      if (user?.email) {
        await Moe.identifyUser({
          uid: user.id?.toString() ?? '',
          u_em: user.email,
        });
        Moe.setEmailId(user.email);
        if (user.first_name) Moe.setFirstName(user.first_name);
        if (user.last_name) Moe.setLastName(user.last_name);
        if (user.birth_date) Moe.setBirthDate(new Date(user.birth_date));
        if (user.phone) Moe.setMobileNumber(user.phone);
      } else if (moeUserEmail) {
        Moe.logoutUser();
      }
    } catch (error) {
      console.error('Error identifying through Moengage', error);
    }
  }
};
/* eslint-enable import-x/no-named-as-default-member */

export const useMoengageIdentify = (user: Partial<User> | null) => {
  useEffect(() => {
    if (user === null) return;
    identifyToMoengage(user);
  }, [user]);
};
